<template>
  <div>
    <div class="control-zoom">
      <b-button variant="light"
        class="btn-round opacity-level"
        @click.prevent="minusValue"
      >
        <font-awesome-icon :icon="['fas', 'minus']" size="sm"/>
      </b-button>
      <span class="percent">Opacité {{ percent }}%</span>
      <b-button variant="light"
        class="btn-round opacity-level"
        @click.prevent="plusValue"
      >
        <font-awesome-icon :icon="['fas', 'plus']" size="sm"/>
      </b-button>
    </div>
    <b-form-input
      v-model="value"
      type="range"
      min="0" max="1"
      step="0.01"
      @update="handleChange"
    >
    </b-form-input>

  </div>
</template>

<script>
export default {
  props: {
    opacity: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      value: 1
    }
  },
  watch: {
    opacity (val) {
      this.value = Number(val)
    }
  },
  computed: {
    percent () {
      return Math.floor(Number(this.value) * 100)
    }
  },
  mounted () {
    this.value = Number(this.opacity)
  },
  methods: {
    handleChange (value) {
      this.value = value
      this.$emit('change', Number(value))
    },
    minusValue () {
      this.value = Number(this.value) > 0 ? Number(this.value) - 0.01 : 0
    },
    plusValue () {
      this.value = Number(this.value) < 1 ? Number(this.value) + 0.01 : 1
    }
  }
}
</script>

<style lang="scss" scoped>
  .control-zoom {
    display: flex;
    align-items: center;
    span  {
      padding-left: 15px;
      padding-right: 15px;
      font-size: 8px;
      color: #2b3085;
      line-height: 0px;
      font-weight: bold;
    }
  }
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 1px solid #2b3085;
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: #2b3085;
    cursor: pointer;
    margin-top: 0;
    box-shadow: none;
  }

  .custom-range {
    height:1px;
  }

  .opacity-level {
    width:9px;
    height:9px;
    padding: 4px;
    font-weight: bold;
  }

  .control-zoom {
    padding:0 10px;
    padding-top:1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/opacityUI.vue